var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68515 13.198C0.312031 7.37311 4.59731 1 10.8871 1H11.2264C15.9303 1 19.7436 4.81327 19.7436 9.51712C19.7436 14.7544 15.4979 19 10.2607 19H2.00472C1.66874 19 1.36932 18.7879 1.25782 18.471C1.1463 18.1541 1.24696 17.8012 1.50893 17.5908L3.59027 15.9193C3.68128 15.8463 3.71347 15.7221 3.66943 15.614L2.68515 13.198ZM10.8871 2.58358C5.72194 2.58358 2.2029 7.8172 4.15169 12.6006L5.13597 15.0166C5.44424 15.7732 5.2189 16.6425 4.58185 17.1541L4.25516 17.4164H10.2607C14.6234 17.4164 18.16 13.8798 18.16 9.51712C18.16 5.68786 15.0558 2.58358 11.2264 2.58358H10.8871Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.78614438f22e4d9558c914b104108691.svg";
export { ForwardRef as ReactComponent };